import React, { createContext, useContext } from "react";
const CellCacheContext = createContext(void 0);
const CellCacheContextProvider = ({ queryCache, children }) => {
  return /* @__PURE__ */ React.createElement(CellCacheContext.Provider, { value: { queryCache } }, children);
};
function useCellCacheContext() {
  const context = useContext(CellCacheContext);
  if (!context) {
    throw new Error(
      "useCellCacheContext must be used within a CellCacheContextProvider"
    );
  }
  return context;
}
export {
  CellCacheContextProvider,
  useCellCacheContext
};
